import { render } from "./CheckoutModal.vue?vue&type=template&id=070880c9&scoped=true"
import script from "./CheckoutModal.vue?vue&type=script&lang=js"
export * from "./CheckoutModal.vue?vue&type=script&lang=js"

import "./CheckoutModal.vue?vue&type=style&index=0&id=070880c9&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-070880c9"

export default script